import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Compass, ArrowUpRight } from "lucide-react";
import { JOURNEY } from "../data/journey";

const ROUTE = JOURNEY.map((s) => [s.lat, s.lng]);
const TILE_URL = `https://api.maptiler.com/maps/toner-v2/{z}/{x}/{y}.png?key=${process.env.REACT_APP_MAPTILER_KEY}`;

// A decorative, non-interactive antique-styled preview of Bashō's route.
// The whole surface is a button that navigates to the full interactive map.
export default function AntiqueMap({ to = "/map" }) {
  const el = useRef(null);
  const mapRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (mapRef.current || !el.current) return;
    const map = L.map(el.current, {
      center: [37.9, 139.3],
      zoom: 5,
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false,
      touchZoom: false,
    });
    mapRef.current = map;
    L.tileLayer(TILE_URL, {
      maxZoom: 20,
    }).addTo(map);
    L.polyline(ROUTE, { color: "#7a2e12", weight: 2, opacity: 0.9, dashArray: "1 7", lineCap: "round" }).addTo(map);
    JOURNEY.forEach((s) => {
      L.marker([s.lat, s.lng], {
        interactive: false,
        icon: L.divIcon({ className: "", html: `<div class="antique-dot"></div>`, iconSize: [10, 10], iconAnchor: [5, 5] }),
      }).addTo(map);
    });
    setTimeout(() => map.invalidateSize(), 250);
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  return (
    <div className="antique-map relative border-[7px] border-double border-[#7a5a2e]/50 shadow-sm">
      <div ref={el} className="w-full h-[420px]" style={{ background: "#e6dabc" }} />
      <button
        type="button"
        onClick={() => navigate(to)}
        data-testid="antique-map-link"
        aria-label="Open Bashō's interactive map of travels"
        className="group absolute inset-0 z-[600] flex flex-col items-center justify-center text-center"
      >
        <span className="hanko text-[#5a3a18] text-3xl opacity-80">奥の細道</span>
        <span className="mt-2 inline-flex items-center gap-2 bg-[#f4ead2]/85 text-[#3a2a12] px-4 py-2 text-sm tracking-wide border border-[#7a5a2e]/50 opacity-0 group-hover:opacity-100 transition-opacity">
          <Compass className="w-4 h-4" /> Open the interactive map <ArrowUpRight className="w-3.5 h-3.5" />
        </span>
      </button>
    </div>
  );
}
